import React, { useState } from 'react'
import {
    Stack,
    TextField,
    Typography,
    Menu,
    Button,useTheme
} from "@mui/material";
import FilterButtons from './FilterButtons';
import { styled, alpha } from '@mui/material/styles';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 4,
        marginTop: 16,
        minWidth: '11%',
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            '0px 3px 6px #00000029;',
        '& .MuiMenu-list': {
            padding: '0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));


export default function ItemsOrdersFilter({ headData, onChange  }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const theme = useTheme();
    const [selectValue, setValue] = useState({
        minOrder: headData.filter.minOrder || null,
        maxOrder: headData.filter.maxOrder || null,
    });

    const handleClose = () => {
        setAnchorEl(null);
    };


    const handleDropDownClick = (event) => {
        setAnchorEl(event.currentTarget);
        setValue({
            minOrder: headData.filter.minOrder || null,
            maxOrder: headData.filter.maxOrder || null,
        });
    };

    const handleInputOnChange = (event, type) => {
        const regex = /^[0-9\b]+$/;
        // if value is not blank, then test the regex
        if (event.target.value === '' || regex.test(event.target.value)) {
            if (type === 'min') {
                setValue(existingValues => ({ ...existingValues, minOrder: event.target.value }));
            } else {
                setValue(existingValues => ({ ...existingValues, maxOrder: event.target.value }));
            }
        }
    };

    const handleSubmit = (btntype) => {
        const updateObj = headData;
        if (btntype === 'Reset') {
            updateObj.filter.minOrder = null;
            updateObj.filter.maxOrder = null;
        } else {
            updateObj.filter.minOrder = selectValue.minOrder;
            updateObj.filter.maxOrder = selectValue.maxOrder;
        }
        onChange({ ...updateObj });
        handleClose();
    };

    return (
          <>
            <Button
                style={{
                    background: headData?.filter?.minOrder || headData?.filter?.maxOrder ? theme.palette.primary.main : '',
                    color: headData?.filter?.minOrder || headData?.filter?.maxOrder ? theme.palette.background.main : '',
                }}
            className='!p-[0px] !min-w-[23px] !w-[23px] !h-[23px]  !mr-[10px]' onClick={(event) => {
                handleDropDownClick(event);
            }}
            >
                <ArrowDropDownIcon />
            </Button>

            <StyledMenu
                id="filter-list-menu-checkBox"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
            <Stack direction="row" spacing={1} className='!px-[6px] !py-[12px] !justify-around'>
                <Typography className='!grid !text-[10px]'>
                    <div className='mb-[4px] font-medium'>Min Order</div>
                    <TextField size="small" sx={{
                        width: 47,
                        "& .MuiInputBase-input": {
                            padding: '3px 8px',
                            height: 20,
                            fontSize: '12px !important'
                        }
                    }} variant="outlined" value={selectValue.minOrder} onChange={(e) => { handleInputOnChange(e, 'min') }} />
                </Typography>

                <Typography className='!grid !text-[10px]'>
                    <div className='mb-[4px] font-medium'>Max Order</div>
                    <TextField size="small"
                        className='!p-[0px]'
                        sx={{
                            width: 47,
                            "& .MuiInputBase-input": {
                                padding: '3px 8px',
                                height: 20,
                                fontSize: '12px !important'
                            }
                        }} variant="outlined" value={selectValue.maxOrder} onChange={(e) => { handleInputOnChange(e, 'max') }} />
                </Typography>

            </Stack>

            <Stack direction="row" spacing={1} className='!px-[6px] !py-[12px] !justify-around'>
                <FilterButtons disabled={!selectValue.minOrder && !selectValue.maxOrder} name={`Reset`} onClick={(btnType) => { handleSubmit(btnType) }} />
                <FilterButtons disabled={!selectValue.minOrder && !selectValue.maxOrder} name={`Apply`} onClick={(btnType) => { handleSubmit(btnType) }} />
            </Stack>
            </StyledMenu>
        </>

    )
}
